import React, { useEffect } from 'react';
import digital_farm from '../../assets/digital_farm.png'
import './Profile.css'
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import useToken from '../../useToken'
import { useSelector, useDispatch } from 'react-redux';
import { fetchProfile } from '../../features/profile/profileSlice';

const useStyles = makeStyles({
  title: {
    marginLeft: 10,
    marginRight: 10,
  },
});

const Profile = () => {
    const classes = useStyles();
    const {token, setToken} = useToken()
    const dispatch = useDispatch()
    const profile = useSelector((state: any) => state.profile.profileData);
    const data = profile.data.Data || {}
    const sitearea = profile.data.SiteArea || {}

    useEffect(() => {
      dispatch(fetchProfile({token}))
    }, [dispatch]);

    return (
        <div>
            <Typography variant="h6" className={classes.title}> 
                Company Profile
            </Typography>
            <Grid container justifyContent="space-between">                  
                <Typography display="inline" align="left" variant="body1" className={classes.title}> 
                    Name: 
                </Typography>
                <Typography display="inline" align="right" variant="body2" className={classes.title}> 
                    { data.Name } 
                </Typography>
            </Grid>
            <Grid container justifyContent="space-between">                  
                <Typography display="inline" align="left" variant="body1" className={classes.title}> 
                    Address: 
                </Typography>
                <Typography display="inline" align="right" variant="body2" className={classes.title}> 
                    {data.Address} 
                </Typography>
            </Grid>
            <Grid container justifyContent="space-between">                  
                <Typography display="inline" align="left" variant="body1" className={classes.title}> 
                    Number of Users: 
                </Typography>
                <Typography display="inline" align="right" variant="body2" className={classes.title}> 
                    {data.Users}
                </Typography>
            </Grid>
            <Grid container justifyContent="space-between">                  
                <Typography display="inline" align="left" variant="body1" className={classes.title}> 
                    Site Area (ha.):
                </Typography>
                <Typography display="inline" variant="body2" className={classes.title} > 
                {    
                    Object.keys(sitearea).map((site) => (
                            <label key={site}> ({site}) {sitearea[site]} </label>
                    ))
                }
                </Typography>
            </Grid>
            <img className="farm_pic" src={digital_farm}/>
        </div>
    )
}

export default Profile
